import { render, staticRenderFns } from "./LowerThird.vue?vue&type=template&id=5cd90c62"
import script from "./LowerThird.vue?vue&type=script&lang=js"
export * from "./LowerThird.vue?vue&type=script&lang=js"
import style0 from "./LowerThird.vue?vue&type=style&index=0&id=5cd90c62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports